import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { X } from 'lucide-react'

// Non-modal: charts remain visible and usable behind the window.
export default function FloatingWindow({ title, children, onClose, width = 420, busy = false }) {
  const ref = useRef(null), drag = useRef(null)
  const [position, setPosition] = useState(null)
  function clamp(x, y) {
    const rect = ref.current?.getBoundingClientRect()
    return { x: Math.max(8, Math.min(x, window.innerWidth - (rect?.width || width) - 8)), y: Math.max(8, Math.min(y, window.innerHeight - Math.min(rect?.height || 80, window.innerHeight - 16) - 8)) }
  }
  useEffect(() => {
    const resize = () => setPosition(p => p ? clamp(p.x, p.y) : p)
    window.addEventListener('resize', resize)
    return () => window.removeEventListener('resize', resize)
  }, [])
  return createPortal(<section ref={ref} role="dialog" aria-modal="false" aria-label={title}
    style={{ width, maxHeight: position ? `calc(100dvh - ${position.y + 8}px)` : 'calc(80dvh - 16px)', ...(position ? { left: position.x, top: position.y } : { left: '50%', top: '20%', transform: 'translateX(-50%)' }) }}
    className="fixed z-[10000] max-w-[calc(100vw-16px)] max-h-[calc(100dvh-16px)] overflow-auto rounded-xl border border-border bg-canvas text-ink shadow-2xl"
    onKeyDown={event => { event.stopPropagation(); if (event.key === 'Escape' && !busy) { event.preventDefault(); onClose() } }}>
    <header className="sticky top-0 z-10 bg-canvas flex touch-none select-none items-center justify-between gap-3 border-b border-border px-3 py-2.5 cursor-move"
      onPointerDown={event => { if (event.button !== 0 || event.target.closest('button')) return; const rect = ref.current.getBoundingClientRect(); drag.current = { x: event.clientX - rect.left, y: event.clientY - rect.top }; event.currentTarget.setPointerCapture(event.pointerId) }}
      onPointerMove={event => { if (drag.current) setPosition(clamp(event.clientX - drag.current.x, event.clientY - drag.current.y)) }}
      onPointerUp={() => { drag.current = null }} onPointerCancel={() => { drag.current = null }}>
      <h2 className="text-sm font-semibold">{title}</h2>
      <button type="button" aria-label={`Close ${title}`} disabled={busy} onClick={onClose} className="rounded p-1 text-inkMuted hover:text-ink"><X size={16}/></button>
    </header>
    {children}
  </section>, document.body)
}
